module.exports = __webpack_public_path__ + "img/avatar.c904173e.jpg";